import { updateIn } from 'immutable';
const initial = {
    by_device_id: {},
    upload_success_shown: false,
};
const per_device_initial = {
    downloading: false,
    uploading: false,
    percent: 0,
};
const per_device_reducer = (state = per_device_initial, action) => {
    switch (action.type) {
        case 'DOWNLOAD_SX_CONFIG_FILE':
            return { downloading: true, percent: 0 };
        case 'UPLOAD_SX_CONFIG_FILE':
            return { uploading: true, percent: 0 };
        case 'DOWNLOAD_SX_CONFIG_FILE__PROGRESS':
        case 'UPLOAD_SX_CONFIG_FILE__PROGRESS':
            return { ...state, percent: action.percent };
        case 'DOWNLOAD_SX_CONFIG_FILE__OK':
            return { downloading: false };
        case 'DOWNLOAD_SX_CONFIG_FILE__FAIL':
            return { downloading: false, error: action.error };
        case 'UPLOAD_SX_CONFIG_FILE__OK':
            return { uploading: false };
        case 'UPLOAD_SX_CONFIG_FILE__FAIL':
            return { uploading: false, error: action.error };
        default:
            return state;
    }
};
export const reducer = (state = initial, action) => {
    switch (action.type) {
        case 'DOWNLOAD_SX_CONFIG_FILE':
        case 'DOWNLOAD_SX_CONFIG_FILE__PROGRESS':
        case 'DOWNLOAD_SX_CONFIG_FILE__OK':
        case 'DOWNLOAD_SX_CONFIG_FILE__FAIL':
        case 'UPLOAD_SX_CONFIG_FILE':
        case 'UPLOAD_SX_CONFIG_FILE__PROGRESS':
        case 'UPLOAD_SX_CONFIG_FILE__OK':
        case 'UPLOAD_SX_CONFIG_FILE__FAIL': {
            const new_state = updateIn(state, ['by_device_id', action.device_id], 
            //@ts-ignore
            (devstate) => per_device_reducer(devstate, action));
            if (action.type === 'UPLOAD_SX_CONFIG_FILE__OK')
                new_state.upload_success_shown = true;
            return new_state;
        }
        case 'CLOSE_UPLOAD_SX_CONFIG_SUCCESS':
            return { ...state, upload_success_shown: false };
        default:
            return state;
    }
};
